// src/App.tsx
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { ValueRibbon } from "./components/ValueRibbon";
import { ServiceGrid } from "./components/ServiceGrid";
import { TechCloud } from "./components/TechCloud";
import { SupportCTA } from "./components/SupportCTA"; // New
import { Footer } from "./components/Footer"; // New
import { ContactForm } from "./components/ContactForm";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <ValueRibbon />
      <ServiceGrid />
      <TechCloud />
      <SupportCTA />
      <ContactForm /> {/* Form added here */}
      <Footer />
    </>
  );
}

export default App;
